import type { Connection, Evaluate } from '@particle-network/connector-core';
import type { Config } from '../createConfig';
import { deepEqual } from '../utils/deepEqual';

export type GetConnectionsReturnType = Evaluate<Connection>[];

let previousConnections: Connection[] = [];

export function getConnections(config: Config): GetConnectionsReturnType {
  if (config.state.status === 'reconnecting') return previousConnections;

  const connections = [...config.state.connections.values()];
  const current = config.state.current;
  connections.sort((a, b) => {
    if (a.connector.uid === current) {
      return -1;
    }

    if (b.connector.uid === current) {
      return 1;
    }
    return 0;
  });
  if (deepEqual(previousConnections, connections)) return previousConnections;

  previousConnections = connections;
  return connections;
}
